// extracted by mini-css-extract-plugin
export default {"defi":"DefiBlock_defi__MX1vg","title":"DefiBlock_title__jwZ4x","defi_main":"DefiBlock_defi_main__jPTQF","defi_main_mobile":"DefiBlock_defi_main_mobile__rkCMb"};